/*
 * @license
 * Copyright© Celligence International, LLC - 2023
 *
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
 *
 */
import React from "react";
import Spinner from 'react-bootstrap/Spinner';

export default function SpinnerLoader() {
    return (
        <div className="text-center mt-5 mb-5">
            <Spinner animation="border" role="status" />
            <span>Loading...</span>
        </div>
    );
};